import { render, staticRenderFns } from "./CardSlider.vue?vue&type=template&id=cc6305b2&scoped=true&"
import script from "./CardSlider.vue?vue&type=script&lang=js&"
export * from "./CardSlider.vue?vue&type=script&lang=js&"
import style0 from "./CardSlider.vue?vue&type=style&index=0&id=cc6305b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6305b2",
  null
  
)

export default component.exports